// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hmZx","buttons":"Footer_buttons__2_Kdm"};